import React, { useEffect, useState } from 'react'
import { Address, useDioxAddressContext, useDioxNetWork } from 'common/hooks'
import { seesaw } from 'common/utils'
import CopyText from '../CopyText'
import styled from 'styled-components'
import clss from 'classnames'
import { AppProp } from './wrap'
import { LazyImg, Linker } from 'common/ui'
import defaultAddress from '../../../assets/img/default-address.png'

const HeaderStyled = styled.header`
  width: 100%;
  background: #1a1919;
  color: #ffffff;
  position: relative;
  z-index: 2;
  &:after {
    content: '';
    width: 100%;
    height: 1px;
    background: #3a3939;
    position: absolute;
    bottom: -0.5px;
    left: 0;
  }
  .header-container {
    height: 72px;
    display: flex;
    align-items: center;
    width: 1326px;
    margin: 0 auto;
    background: #1a1919;
    position: relative;
    &:after {
      content: '';
      width: 100%;
      height: 1px;
      background: #3a3939;
      position: absolute;
      bottom: -0.5px;
      left: 0;
    }
  }
  .flex-logo {
    flex: 1;
  }
  .logo {
    display: inline-flex;
    align-items: center;
    text-decoration: unset;
    img {
      width: 48px;
      height: 48px;
    }
    .title {
      margin-left: 12px;
      font-size: 20px;
      font-weight: 600;
      line-height: 24px;
      color: #ffffff;
    }
  }
  .net {
    margin-right: 40px;
    padding: 12px 20px;
    border-radius: 21px;
    height: 42px;
    background: #1a1919;
    border: 1px solid #3a3939;
    font-size: 14px;
    color: #a3a3a3;
    line-height: 17px;
    font-weight: 400;
    &::before {
      content: '';
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 100%;
      margin-right: 8px;
      background: #00cc88;
    }
  }
  .addr-box {
    display: flex;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
      border-radius: 100%;
      margin-right: 12px;
    }
    .alias {
      font-size: 16px;
      color: #ffffff;
      font-weight: 500;
      line-height: 20px;
      margin-bottom: 4px;
    }
    .addr {
      font-size: 14px;
      color: #a3a3a3;
      line-height: 17px;
      font-weight: 400;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .copy {
      margin-left: 4px;
    }
  }
  .not-connected {
    padding: 12px 20px;
    border-radius: 21px;
    height: 42px;
    background: #1a1919;
    border: 1px solid #3a3939;
    color: #ec404e;
    font-size: 14px;
    line-height: 17px;
    &::before {
      content: '';
      display: inline-block;
      width: 8px;
      height: 8px;
      background: #ec404e;
      border-radius: 100%;
      margin-right: 8px;
    }
  }
`

export type HeaderProp = {
  app: AppProp
  className?: string
}
const Header = ({ app, className }: HeaderProp) => {
  const { logo, title } = app
  const netWork = useDioxNetWork()
  const { address } = useDioxAddressContext()
  const [cacheAddress] = useState<Address | null>(address)

  useEffect(() => {
    // 切换地址返回首页
    if (address && cacheAddress && address?.address !== cacheAddress?.address) {
      window.location.href = '/'
    }
  }, [address, cacheAddress])

  return (
    <HeaderStyled className={className}>
      <div className="header-container">
        <div className="flex-logo">
          <Linker href="/" className="logo">
            {logo && <img src={logo} alt="logo" />}
            <h1 className="title">{title}</h1>
          </Linker>
        </div>
        {address && <div className={clss(`id${netWork?.id}`, 'net')}>{netWork?.name}</div>}
        <div className="addr-box">
          {address ? (
            <>
              <LazyImg url={address.avatar} defaultUrl={defaultAddress.src} alt="addr" />
              <div className="addr-name">
                <p className="alias">{address.alias || ''}</p>
                <div className="addr font-mono">
                  {seesaw({ raw: address?.address || '', isAddress: true })}
                  <CopyText className="ml-8" text={address.address} />
                </div>
              </div>
            </>
          ) : (
            <div className="not-connected">Not Connected</div>
          )}
        </div>
      </div>
    </HeaderStyled>
  )
}
export default Header
